export default __webpack_public_path__ + "static/media/fog.a6733a73.svg";